module.exports = __webpack_public_path__ + "img/041.8c1a9196.png";